import { toast } from "react-toastify";

const makeToast = ({ message }: { message: string }) => {
  toast({ message });
};

export { makeToast };
